import React from 'react';
import { gqlArtist } from '@minecraft.graphql-types';
import { AccountArtistFragment } from '@minecraft.graphql-operations';
import { sortArtists } from 'utils/helpers';
import SCREEN_NAMES from 'config/constants/screenNames';
import { INFO_MAX_LENGTH } from 'config/constants/profile';
import ArtistsInfo from 'components/Artists/ArtistsInfo';
import { ArtistInfo, ArtistsListWrapper, MobileArtistInfo } from 'components/core/NavLoggedIn/Styles';

interface ArtistsListProps<T extends gqlArtist | AccountArtistFragment> {
  showAllArtists?: boolean;
  isMobile: boolean;
  artists: T[];
  selected: T;
  Component: React.FC<{ $selected?: boolean }>;
  handleArtistSelect: (artist: T) => void;
}

const ArtistsList = <T extends gqlArtist | AccountArtistFragment>({
  showAllArtists = false,
  isMobile,
  artists,
  selected,
  Component,
  handleArtistSelect,
}: ArtistsListProps<T>) => {
  if (!Array.isArray(artists)) {
    return null;
  }

  return (
    <ArtistsListWrapper>
      {sortArtists(showAllArtists ? artists : artists.filter((a) => a.artistId !== selected.artistId)).map((artist) => (
        <Component $selected={artist.artistId === selected.artistId} key={artist.artistId}>
          {isMobile ? (
            <MobileArtistInfo
              data-qa-id={`${SCREEN_NAMES.NAVIGATION_LINK}-artist`}
              data-testid={`selectable-artist-${artist.artistId}`}
              onClick={(): void => handleArtistSelect(artist)}
            >
              <ArtistsInfo artist={artist} showInfo={false} maxLength={INFO_MAX_LENGTH} />
            </MobileArtistInfo>
          ) : (
            <ArtistInfo
              data-qa-id={`${SCREEN_NAMES.NAVIGATION_LINK}-artist`}
              data-testid={`selectable-artist-${artist.artistId}`}
              onClick={(): void => handleArtistSelect(artist)}
            >
              <ArtistsInfo artist={artist} showInfo={false} />
            </ArtistInfo>
          )}
        </Component>
      ))}
    </ArtistsListWrapper>
  );
};

export default ArtistsList;
